import { Button, CircularProgress, Dialog } from '@material-ui/core';
import React from 'react';
import { useBreakpoints } from 'utils/use-breakpoints';
import { CustomiseTraits } from './customise-traits';
import { CustomisableTrait, TraitScenarioOption, TraitSelectionId } from './customise-traits-utils';

export interface CustomiseTraitsButtonProps<T extends CustomisableTrait> {
  availableTraits: T[];
  selectedTraitIds: TraitSelectionId[];
  defaultTraitIds: TraitSelectionId[];
  disabled?: boolean;
  loading?: boolean;
  onSave: (selectedTraitIds: TraitSelectionId[]) => void;
  maxTraits?: number;
  title?: string;
  scenarios?: TraitScenarioOption[];
  selectedScenarioId?: number | null;
  onScenarioChange?: (scenarioId: number) => Promise<TraitSelectionId[]> | TraitSelectionId[];
}

export const CustomiseTraitsButton = <T extends CustomisableTrait>({
  availableTraits,
  selectedTraitIds,
  defaultTraitIds,
  disabled,
  loading,
  onSave,
  maxTraits,
  title,
  scenarios,
  selectedScenarioId,
  onScenarioChange,
}: CustomiseTraitsButtonProps<T>) => {
  const [open, setOpen] = React.useState(false);
  const { phone } = useBreakpoints();

  const save = (traitIds: TraitSelectionId[]) => {
    onSave(traitIds);
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        disabled={disabled || loading}
        startIcon={loading && <CircularProgress color="inherit" size={20} />}
        onClick={() => setOpen(true)}
      >
        Customise traits
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        fullScreen={phone}
        maxWidth="lg"
      >
        <CustomiseTraits
          availableTraits={availableTraits}
          selectedTraitIds={selectedTraitIds}
          defaultTraitIds={defaultTraitIds}
          onCancel={() => setOpen(false)}
          onSave={save}
          maxTraits={maxTraits}
          title={title}
          scenarios={scenarios}
          selectedScenarioId={selectedScenarioId}
          onScenarioChange={onScenarioChange}
        />
      </Dialog>
    </>
  );
};
